export default "__VITE_ASSET__BckerM8h__"